const getDefaultState = () => {
	return {
		suggestion_table: [],
	}
}

const default_state = getDefaultState()

export { default_state }